import {
  Button,
  Layout,
  theme,
  Form,
  Input,
  Select,
  Spin,
  notification,
} from "antd";

import React, { useState } from "react";
import "../CreateRole/CreateRole.css";

import { Row, Col } from "antd";
import { Link, useNavigate } from "react-router-dom";
import TopHeader from "../../common/TopHeader/TopHeader";
import Sidebar from "../../common/Sidebar/Sidebar";
// import FooterDashboard from "../../common/FooterDashboard/FooterDashboard";
import DesignationApi from "../../common/Apis/DesignationApi";
import DepartmentDropdown from "../../common/DropDowns/Department";
import ParentDesignation from "../../common/DropDowns/ParentDesignation";

const AddDesignations = () => {
  const navigate = useNavigate();
  const { Content } = Layout;
  const [loadings, setLoadings] = useState(false);
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));

  const {
    token: { colorBgContainer },
  } = theme.useToken();

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleSubmit = (data) => {
    setLoadings(true);
    let formData = JSON.stringify({
      code: data?.code,
      parentDesignationId:
        data?.parentDesignation === "No_Parent_Designation"
          ? null
          : data?.parentDesignation,
      designationCategory: data?.designationCategory,
      description: data?.description,
      institutionDTO: {
        id: data?.institutionId,
      },
      tenantDTO: {
        id: decodedToken?.tenantId,
        tenantApiKey: decodedToken?.tenantApiKey,
      },
      topperOfHierarchy:
        data?.parentDesignation === "No_Parent_Designation" ? true : false,
    });
    console.log(formData);
    DesignationApi.CreateDesignation(formData)
      .then((response) => {
        setLoadings(false);
        notification.open({
          message: <span style={{ fontWeight: "bold" }}>Successfully</span>,
          description: "Create Successfully",
          closeIcon: false,
          duration: 3,
          style: {
            backgroundColor: "#b3ffb3",
            color: "green",
          },
        });
        return navigate("/masters/designations");
      })
      .catch((err) => {
        if (err.apiError.status) {
          setLoadings(false);
          notification.open({
            message: <span style={{ fontWeight: "bold" }}>Error</span>,
            description: err.apiError.message,
            closeIcon: false,
            duration: 3,
            style: {
              backgroundColor: "#fff2f0",
              color: "red",
            },
          });
        }
      });
  };

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar />
      <Layout>
        <TopHeader />

        <Content
          className="form-content nav-content"
          style={{
            margin: "16px 16px 0",
            padding: "30px",
            background: colorBgContainer,
          }}
        >
          <Form
            name="nest-messages"
            layout="vertical"
            className="FormClass"
            onFinish={handleSubmit}
          >
            <>
              <Row gutter={24}>
                <Col lg={9} md={12} >
                  <Form.Item
                    name="code"
                    label="Code *"
                    className="text-lable"
                    rules={[
                      {
                        required: true,
                        message: "Please enter Code.",
                      },
                    ]}
                  >
                    <Input
                      type="text"
                      placeholder="Code"
                      className="control-input"
                    />
                  </Form.Item>
                </Col>

                <Col lg={9} md={12}>
                  <Form.Item
                    name="description"
                    label="Name *"
                    className="text-lable"
                    rules={[
                      {
                        required: true,
                        message: "Please enter Name.",
                      },
                    ]}
                  >
                    <Input
                      type="text"
                      placeholder="Name"
                      className="control-input"
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={24}>
                <Col lg={9} md={12}>
                  <ParentDesignation />
                </Col>
                <Col lg={9} md={12}>
                  <DepartmentDropdown />
                </Col>
              </Row>

              <Row gutter={24}>
                <Col span={9}>
                  <Form.Item
                    name="designationCategory"
                    label="Designation Category *"
                    className="text-lable"
                    rules={[
                      {
                        required: true,
                        message: "Please Select Designation Category.",
                      },
                    ]}
                  >
                    <Select
                      className="control-Select mb-1"
                      placeholder="Select Designation Category"
                    >
                      <option value="CHEF">Chef</option>
                      <option value="MANAGER">Manager</option>
                      <option value="ENGINEER">Engineer</option>
                      <option value="ANALYST">Analyst</option>
                      <option value="BAKER">Baker</option>
                      <option value="BUTCHER">Butcher</option>
                      <option value="BARISTA">Barista</option>
                      <option value="CHOCOLATIER">Chocolatier</option>
                      <option value="SOMMELIER">Sommelier</option>
                      <option value="FOOD_SCIENTIST">Food Scientist</option>
                      <option value="FARMER">Farmer</option>
                      <option value="FISHERMAN">Fisherman</option>
                      <option value="BREWER">Brewer</option>
                      <option value="VINTNER">Vintner</option>
                      <option value="SPICE_MASTER">Spice Master</option>
                      <option value="BEEKEEPER">Beekeeper</option>
                      <option value="CONFECTIONER">Confectioner</option>
                      <option value="CATERING_MANAGER">Catering Manager</option>
                      <option value="NUTS_SPECIALIST">Nuts Specialist</option>
                      <option value="SANDWICH_ARTIST">Sandwich Artist</option>
                      <option value="BEVERAGE_SPECIALIST">Beverage Specialist</option>
                      <option value="DESSERT_CHEF">Dessert Chef</option>
                      <option value="ORGANIC_SPECIALIST">Organic Specialist</option>
                      <option value="ETHNIC_CUISINE_CHEF">Ethnic Cuisine Chef</option>
                      <option value="GLUTEN_FREE_SPECIALIST">Gluten-Free Specialist</option>
                      <option value="FOOD_INSPECTOR">Food Inspector</option>
                      <option value="MENU_PLANNER">Menu Planner</option>
                      <option value="DIETITIAN">Dietitian</option>
                      <option value="FOOD_WRITER">Food Writer</option>
                      <option value="FOOD_STYLIST">Food Stylist</option>
                      <option value="FOOD_PHOTOGRAPHER">Food Photographer</option>

                    </Select>
                  </Form.Item>
                </Col>

              </Row>

              {/* <div className="d-flex justify-content-end pt-5">
                <Link
                  type="primary"
                  to={""}
                  onClick={handleGoBack}
                  className="btn btn-primary btn-back"
                >
                  Back
                </Link>

                <Button
                  type="primary"
                  htmlType="submit"
                  className="btn btn-primary btn-save"
                >
                  Create {loadings == true && <Spin className="px-2" />}
                </Button>
              </div> */}
              <div
                className="d-flex justify-content-between pt-5"
                style={{
                  gap: "10px",
                }}
              >
                <Button
                  onClick={handleGoBack}
                  style={{
                    flex: 1,
                    height: 40,
                    borderRadius: 6,
                  }}
                >
                  Back
                </Button>

                <Button
                  type="primary"
                  htmlType="submit"
                  style={{
                    flex: 1,
                    height: 40,
                    borderRadius: 6,
                  }}
                >
                  Save & Continue {loadings && <Spin size="small" className="px-2" />}
                </Button>
              </div>
            </>
          </Form>
        </Content>
        {/* <FooterDashboard /> */}
      </Layout>
    </Layout>
  );
};
export default AddDesignations;
